<script setup>
import {ref, reactive, onUpdated, onBeforeMount} from "vue"
import YTGender from "@/components/YTGender/index.vue"
import {updateClubUser} from "@/api/club/club.js";
import {editStoreMemberApplicationsNew} from "@/api/storeMemberApplications/storeMemberApplications.js";
import {debounceFn} from "@/hooks/debounce.js";
import {tagGroupsListByUsageScenario} from "@/api/tagGroup/tagGroup.js";
import YTTagSelect from "@/components/YTTagSelect/index.vue";

/*数据更新*/
onUpdated(() => {
  console.log("run in onUpdated", props.auditCacheDate)
  dialogForm.id = props.auditCacheDate.id ? props.auditCacheDate.id : null
  dialogForm.userId = props.auditCacheDate.userId ? props.auditCacheDate.userId : null
  dialogForm.reason = props.auditCacheDate.reason ? props.auditCacheDate.reason : null
  dialogForm.remarks = props.auditCacheDate.remarks ? props.auditCacheDate.remarks : null
  dialogForm.phone = props.auditCacheDate.phone ? props.auditCacheDate.phone : null
  dialogForm.tagList = props.auditCacheDate.tagList ? props.auditCacheDate.tagList : []
  // 标签列表大于0，触发标签弹窗反显
  if (dialogForm.tagList.length > 0) YTTagSelectRef.value.handleYTCheckTagMultipleReview(dialogForm.tagList)
})

/*请求数据*/
onBeforeMount(async () => {
  await handleGetTagsList('init')
})

/*标签选择器组件相关*/
// 标签列表
const tagList = ref([])
// 标签当前页
const currentTagPage = ref(1)
// 标签弹窗翻页是否有下一页
const hasNextPage = ref(true)
// 标签选择器组件锚点
const YTTagSelectRef = ref()
// 处理弹窗标签翻页
const handleTagListPageTurning = debounceFn(async () => {
  if (hasNextPage.value) {
    currentTagPage.value++
    await handleGetTagsList('nextPage')
    // 保证翻页后的内容同样回显
    YTTagSelectRef.value.handleYTCheckTagMultipleReview(dialogForm.tagList)
  }
})
// 获取标签列表
const handleGetTagsList = async (type = 'init') =>  {
  try {
    loading.value = true
    const res = await tagGroupsListByUsageScenario({usageScenario: "MEMBER"})
    console.log("res", res)
    if (type === 'init') {
      tagList.value = res
    } else {
      res.map(item => {
        tagList.value.push(item)
      })
    }
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 标签改变
const handleMemberTagChange = (list) => {
  dialogForm.tagList = list.flatMap(i => i.tagList.length > 0 ? i.tagList.filter(tag => tag.checked).map(item => ({ tagId: item.tagId, tagName: item.tagName })) : [])
}

// 内容是否有修改
const isChange = ref(false)

// 事件
const emit = defineEmits(['close', 'success', 'reject'])

// 父组件传值
const props = defineProps({
  // 审核对话框类型
  type: {
    required: true,
    type: String
  },
  // 审核弹窗缓存数据
  auditCacheDate: {
    required: true,
  }
})
// 对话框打开状态
const open = ref(false)
// 加载状态
const loading = ref(false)
// 处理对话框关闭
const handleClose = () => {
  open.value = false
  dialogForm.id = null
  dialogForm.userId = null
  dialogForm.reason = null
  dialogForm.remarks = null
  dialogForm.phone = null
  dialogForm.tagList = []
  isChange.value = false
  dialogFormRef.value.clearValidate()
  YTTagSelectRef.value.handleYTCheckTagMultipleReset()
  emit('close')
}
// 处理对话框打开
const handleOpen = () => {
  open.value = true
}
// 表单锚点
const dialogFormRef = ref()
// 表单数据
const dialogForm = reactive({
  id: null,
  userId: null,
  reason: null,
  remarks: null,
  phone: null,
  tagList: []
})
// 拒绝通过校验规则
const rulesOne = {
  reason: [
    {required: true, message: "请输入会员入会失败原因", trigger: "blur"}
  ]
}
// 通过校验规则
const rulesTwo = {
  // phone: [
  //   {required: true, message: "请输入会员手机号", trigger: "blur"}
  // ],
  // remarks: [
  //   {required: true, message: "请输入其他补充信息", trigger: "blur"}
  // ]
}
// 表单校验规则
const dialogRules = ref(rulesOne)
// 处理对话框提交表单
const handleSubmit = () => {
  dialogFormRef.value.validate(async (valid) => {
    if (valid) {
      if (props.type === "reject") {
        await handleRejected()
      } else {
        try {
          let tempID = []
          dialogForm.tagList.map(item => {
            tempID.push(item.tagId)
          })
          let param = {
            userId: dialogForm.userId,
            phone: dialogForm.phone,
            remarks: dialogForm.remarks,
            tagIdSet: tempID
          }
          await updateClubUser(param)
          emit("success")
        } catch (e) {
          console.log(e)
        }
      }
    } else {
      ElMessage({
        message: "请根据提示修改表单信息",
        type: "error",
        appendTo: "#phoneDialog"
      })
    }
  })

}
// 处理表单校验规则切换
const handleChangeRules = (type) => {
  if (type === 'reject') {
    dialogRules.value = rulesOne
  } else if (type === 'pass') {
    dialogRules.value = rulesTwo
  }
}
// 拒绝会员申请
const handleRejected = async (item) => {
  try {
    let param = {
      id: dialogForm.id,
      state: "REJECTED",
      reason: dialogForm.reason
    }
    await editStoreMemberApplicationsNew(param)
    emit("reject")
  } catch (err) {
    console.log(err)
  }
}

// 处理点击添加标签
const handleClickAddTag = (visible) => {
  if (!isChange.value) isChange.value = true
}

// 处理点击删除标签
const handleRemoveTag = (tagId) =>{
  isChange.value = true
  const resIndex = dialogForm.tagList.findIndex(i => i.tagId === tagId)
  dialogForm.tagList.splice(resIndex, 1)
  YTTagSelectRef.value.handleYTCheckTagMultipleRemove(tagId)
}

defineExpose({
  handleClose,
  handleOpen,
  handleChangeRules
})
</script>

<template>
  <el-dialog
      id="dialog"
      v-model="open"
      width="500"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div class="yt_dialog_title" style="padding-bottom: 30px">{{props.type === 'reject' ? '会员审核' : '会员资料更新'}}</div>
    </template>
    <div class="flex_center" style="margin-bottom: 1px">
      <div class="yt_dialog_userInfo_box">
        <div class="yt_dialog_userInfo_title">
          会员信息
        </div>
        <div class="flex_center w-100 mg_b_2" style="margin-top: 7px;width: 144px;">
          <div class="flex_center mg_r_2">
            <img style="width: 46px;height: 46px;border-radius: 46px;" :src="props.auditCacheDate.avatar ? props.auditCacheDate.avatar : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'" />
          </div>
          <div class="flex_center">
            <div class="txt_overflow yt_dialog_userInfo_name" style="max-width: 100px;margin-right: 11px;">{{props.auditCacheDate?.nickname}}</div>
            <YTGender :gender="auditCacheDate.gender" :is-small="true"></YTGender>
          </div>
        </div>
        <div class="flex_center">
          <div style="display: inline-block">
            <div class="flex_left flex_align_t" style="margin-bottom: 10px">
              <div class="mg_r_3 flex_center">
                <div class="yt_dialog_userInfo_item_title mg_r_1">FTP</div>
                <div class="yt_dialog_userInfo_item_content">{{props.auditCacheDate?.ftp ? props.auditCacheDate?.ftp + "W" : "—"}}</div>
              </div>
              <div class="flex_center">
                <div class="yt_dialog_userInfo_item_title mg_r_1">车辆品牌</div>
                <div class="yt_dialog_userInfo_item_content">{{props.auditCacheDate?.carBrand ? props.auditCacheDate?.carBrand : "—"}}</div>
              </div>
            </div>
            <div class="flex_left flex_align_t">
              <div class="yt_dialog_userInfo_item_title mg_r_1" style="width: 48px;">骑行喜好</div>
              <!--TODO 最多30个字符，超过后会移除-->
              <div class="yt_dialog_userInfo_item_content" style="font-weight: 500;max-width: 200px;max-height: 39px;overflow: hidden;">—</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="yt_dialog_container">
      <el-form
          ref="dialogFormRef"
          style="max-width: 385px;"
          :model="dialogForm"
          :rules="dialogRules"
          label-width="auto"
          class="demo-ruleForm"
          status-icon
          v-loading="loading"
          id="dialogForm"
      >
        <el-form-item label=" " style="margin-bottom: 11px">
          <div class="yt_tag_tips" v-if="dialogForm.tagList?.length >= 5" >当前最多支持5个标签，添加新标签需替换已有标签</div>
        </el-form-item>
        <div v-if="props.type === 'reject'">
          <el-form-item label="拒绝理由：" prop="reason">
            <el-input maxlength="20" show-word-limit style="width: 272px" :class="dialogForm.reason === null || dialogForm.reason === '' ? 'input-null' : 'input-filled'" v-model="dialogForm.reason" placeholder="输入会员入会失败原因"></el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="添加标签：">
            <YTTagSelect :limit="5" ref="YTTagSelectRef" :selectedCount="dialogForm.tagList?.length" :width="416" :tagList="tagList" :hasNextPage="hasNextPage" @tagChange="handleMemberTagChange" @pageTurning="handleTagListPageTurning">
              <template #trigger="{ toggle, visible }">
                <div class="flex_left flex_align_t">
                  <div class="flex_center mg_r_1" @click="toggle" v-if="dialogForm.tagList.length < 5">
                    <img v-if="!isChange" @click="handleClickAddTag(visible)" class="cursor-pointer" style="width: 37px;height: 29px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/auditDialog/auditDialog/addTag.svg"/>
                    <img v-else class="cursor-pointer" style="width: 37px;height: 29px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/auditDialog/auditDialog/addTag_active.svg"/>
                  </div>
                  <div class="flex_left flex_warp" @click.stop>
                    <div class="yt_tag_small_box flex_center mg_r_1" v-for="(item, index) in dialogForm.tagList">
                      <div class="yt_tag_small_txt">{{item.tagName}}</div>
                      <div class="yt_tag_small_spaceLine"></div>
                      <div class="yt_tag_small_removeBtn" @click="handleRemoveTag(item.tagId)">×</div>
                    </div>
                  </div>
                </div>
              </template>
            </YTTagSelect>
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input @click="isChange = true" style="width: 272px" :class="dialogForm.phone === null || dialogForm.phone === '' ? 'input-null' : 'input-filled'" v-model="dialogForm.phone" placeholder="输入会员手机号"></el-input>
          </el-form-item>
          <el-form-item label="添加备注：" prop="remarks">
            <el-input @click="isChange = true" maxlength="20" show-word-limit style="width: 272px" :class="dialogForm.remarks === null || dialogForm.remarks === '' ? 'input-null' : 'input-filled'" v-model="dialogForm.remarks" placeholder="输入其他补充信息"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <template #footer>
      <div class="yt_dialog_footer">
        <v-btn color="#d7d7df" variant="elevated" @click="handleClose">{{props.type === 'reject' ? '取消' : '暂不填写'}}</v-btn>
        <v-btn v-if="isChange || props.type === 'reject'" class="mg_l_2" color="#4CAF50" variant="elevated" @click="handleSubmit">{{props.type === 'reject' ? '确定拒绝' : '完成'}}</v-btn>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.yt_dialog_userInfo_box {
  width: 364px;
  height: 211px;
  border-radius: 12px;
  position: relative;
  background: url("https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/auditDialog/auditDialog/userInfo_bg.svg") no-repeat;
  /*background: url("@/assets/images/auditDialog/userInfo_bg.svg") no-repeat;*/
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 39px;
  font-weight: 500;
  .yt_dialog_userInfo_title {
    height: 27px;
    position: absolute;
    top: 13px;
    left: -5px;
    box-sizing: border-box;
    padding-left: 31px;
    padding-right: 24px;
    font-size: 11px;
    color: #FFFFFF;
    background: url("https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/auditDialog/auditDialog/userInfo_title_bg.svg");
    background-size: 100% 100%;
    line-height: 23px;
  }
  .yt_dialog_userInfo_item_title {
    font-weight: 500;
    font-size: 12px;
    color: #272539;
  }
  .yt_dialog_userInfo_item_content {
    font-weight: 500;
    font-size: 12px;
    color: #272539;
  }
  .yt_dialog_userInfo_name {
    font-weight: 500;
    font-size: 12px;
    color: #272539;
  }
}
.yt_tag_small_box {
  height: 25px;
  background: #F1EBFF;
  border-radius: 15px;
  border: 1px solid #DECEFF;
  box-sizing: border-box;
  padding: 5px 7px;
  color: #B292F1;
  margin-bottom: 7px;
  .yt_tag_small_txt {
    font-weight: 500;
    font-size: 11px;
    line-height: 20px;
    text-wrap: nowrap;
  }
  .yt_tag_small_spaceLine {
    width: 1px;
    height: 13px;
    background-color: #B292F1;
    margin: 0 3px;
  }
  .yt_tag_small_removeBtn {
    font-size: 16px;
    cursor: pointer;
  }
}
.yt_tag_tips {
  font-size: 12px;
  color: #6F717D;
  text-align: left;
}
</style>
